var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
// AUTO-GENERATED CONTENT - DO NOT MANUALLY EDIT - Run 'yarn generate:assets' to update
import Asset from '../asset-internal';
function RedshiftLogomark(_a) {
    var restProps = __rest(_a, []);
    return (_jsxs(Asset, Object.assign({ viewBox: "0 0 32 32" }, restProps, { children: [_jsx("path", { fill: "currentColor", d: "M19.24 2h-5.48v27.407h5.48V2Z", opacity: ".9" }), _jsx("path", { fill: "currentColor", d: "M13.76 2 9.95 4.072v23.33l3.81 2.005V2Z" }), _jsx("path", { fill: "currentColor", d: "M19.24 2v27.407l3.81-2.006V4.072L19.24 2Zm7.621 3.81L29 6.946V24.46l-2.139 1.136V5.81Z", opacity: ".8" }), _jsx("path", { fill: "currentColor", d: "m26.861 25.596-3.81-1.136V6.946l3.81-1.136v19.786ZM4 6.946V24.46l2.139 1.136V5.81L4 6.946Z" }), _jsx("path", { fill: "currentColor", d: "m6.139 5.81 3.81 1.136V24.46l-3.81 1.136V5.81Z", opacity: ".8" })] })));
}
export default RedshiftLogomark;
